import { API } from 'src/utils/interceptor'

const categoriesPath = venueId => `gross-profit/${venueId}/revenue-categories`

const categoryPath = (venueId, categoryId) =>
  `${categoriesPath(venueId)}/${categoryId}`

export const listRevenueCategories = async venueId => {
  const response = await API.get('api2', categoriesPath(venueId))
  return response?.data
}

export const createRevenueCategory = async (venueId, payload) => {
  const response = await API.post('api2', categoriesPath(venueId), {
    body: payload,
  })
  return response?.data
}

export const updateRevenueCategory = async (venueId, categoryId, payload) => {
  const response = await API.patch('api2', categoryPath(venueId, categoryId), {
    body: payload,
  })
  return response?.data
}

export const deactivateRevenueCategory = async (venueId, categoryId) => {
  const response = await API.post(
    'api2',
    `${categoryPath(venueId, categoryId)}/deactivate`,
    { body: {} },
  )
  return response?.data
}

export const reactivateRevenueCategory = async (venueId, categoryId) => {
  const response = await API.post(
    'api2',
    `${categoryPath(venueId, categoryId)}/reactivate`,
    { body: {} },
  )
  return response?.data
}

export const assignRevenueCategoryVenue = async (
  venueId,
  categoryId,
  assignedVenueId,
) => {
  const response = await API.post(
    'api2',
    `${categoryPath(venueId, categoryId)}/venues`,
    { body: { venueId: assignedVenueId } },
  )
  return response?.data
}

export const unassignRevenueCategoryVenue = async (
  venueId,
  categoryId,
  assignedVenueId,
) => {
  const response = await API.del(
    'api2',
    `${categoryPath(venueId, categoryId)}/venues/${assignedVenueId}`,
  )
  return response?.data
}

export const readRevenueDays = async (venueId, from, to) => {
  const response = await API.get(
    'api2',
    `gross-profit/${venueId}/revenue-days`,
    { queryStringParameters: { from, to } },
  )
  return response?.data
}

export const readRevenueDay = async (venueId, date) => {
  const response = await API.get(
    'api2',
    `gross-profit/${venueId}/revenue-days`,
    { queryStringParameters: { date } },
  )
  return response?.data
}

export const saveRevenueDay = async (venueId, payload) => {
  const response = await API.post(
    'api2',
    `gross-profit/${venueId}/revenue-days`,
    { body: payload },
  )
  return response?.data
}
